module.exports = __webpack_public_path__ + "static/yellow-paper-bg-f7d61860ecc8fe8d868c13db01b176ea.jpg";